
import { Component, Vue, Watch } from "vue-property-decorator";
import { VMoney } from "v-money";

@Component({
  components: {},
  directives: { money: VMoney }
})
export default class CompanyLimits extends Vue {
  companies_branches: any = [];
  money: any = {
    decimal: ",",
    thousands: ".",
    prefix: "",
    suffix: "",
    precision: 0,
    masked: true
  };

  async mounted() {
    await this.loadCompany();
  }

  async loadCompany() {
    let response: any = await (this.$root as any)._post(
      `companies/one/${this.$route.params.id}`,
      {
        models: "branches"
      }
    );
    this.companies_branches =
      response.data[0].branches /*.map(branch => {
      branch.companies_branches._limit = branch.companies_branches._limit;
      return branch;
    })*/;
  }

  async updateLimits() {
    for (let i: number = 0; i < this.companies_branches.length; i++) {
      await (this.$root as any)._put(
        `companiesbranches/${this.$route.params.id}/${
          this.companies_branches[i].id
        }`,
        {
          _limit: this.companies_branches[i].companies_branches._limit
            .replace(/\./g, "")
            .replace(",", "."),
          allow_new_request: this.companies_branches[i].companies_branches
            .allow_new_request
        }
      );
    }
    (this.$root as any).notify("Se realizo la actualización con éxito.");
  }
}
